
import {
  isPushNotificationSupported,
  initializePushNotifications,
  registerServiceWorker,
  getUserSubscription,
  createNotificationSubscription,
  sendSubscriptionToPushServer
} from "@/funciones/push/push-notifications.js";


const manejador_push = async (data) => {
  let { base, bases, email } = data
  bases = bases.map(e => { return e.base })

  if (!isPushNotificationSupported()) {
    console.log("El navegador no soporta notificaciones")
    return
  }

  let userConsent = await initializePushNotifications();

  if (userConsent != "granted") {
    console.log("No se inicializarón las notificaciones")
    return
  }
  registerServiceWorker();
  console.log("Se registro el service worker")
  let subscrition = await getUserSubscription();

  /** 
   * Subscripción de usuarios a notificaciones push por distribuidora seleccionada
   * 
   * --> USUARIO SUBSCRITO: Se actualiza la distribuidora en el servidor de notificaciones
   * --> USUARIOS SIN SUBSCRIPCIÓN: Se solicita permiso para mostrar notificaciones push,
   *     si se acepta se agrega al nuevo usuario en el servidor de notificaciones push
   */
  if (subscrition) {
    await sendSubscriptionToPushServer({ subscrition, base, email, bases })    
    return
  }
  let nueva_suscripcion = await createNotificationSubscription();
  if (nueva_suscripcion != null) {
    await sendSubscriptionToPushServer({ subscrition: nueva_suscripcion, base, email, bases })    
    return
  }
  return
};

export default manejador_push

